export const serpFeatures = {
  aboutThisResult: 'About this result',
  answerBox: 'Answer box',
  app: 'App',
  carousel: 'Carousel',
  commercialUnits: 'Commercial units',
  eventItem: 'Event item',
  events: 'Events',
  extendedPeopleAlsoSearch: 'Extended people also search',
  extendedSnippet: 'Extended snippet',
  faq: 'Faq',
  featuredSnippet: 'Featured snippet',
  findResultsOn: 'Find results on',
  googleFlights: 'Google flights',
  googleHotels: 'Google hotels',
  googlePosts: 'Google posts',
  googleReviews: 'Google reviews',
  highlighted: 'Highlighted',
  hotelsPack: 'Hotels pack',
  images: 'Images',
  imagesSearch: 'Images search',
  isFeaturedSnippet: 'Is featured snippet',
  isImage: 'Is image',
  isMalicious: 'Is malicious',
  isVideo: 'Is video',
  isWebStory: 'Is web story',
  jobs: 'Jobs',
  knowledgeGraph: 'Knowledge graph',
  links: 'Links',
  localPack: 'Local pack',
  localServices: 'Local services',
  map: 'Map',
  mapsPaidItem: 'Maps paid item',
  mapsSearch: 'Maps search',
  mentionCarousel: 'Mention carousel',
  multiCarousel: 'Multi carousel',
  newsSearch: 'News search',
  paid: 'Paid',
  peopleAlsoAsk: 'People also ask',
  peopleAlsoSearch: 'People also search',
  podcasts: 'Podcasts',
  popularProducts: 'Popular products',
  preSnippet: 'Pre snippet',
  price: 'Price',
  questionsAndAnswers: 'Questions and answers',
  rating: 'Rating',
  recipes: 'Recipes',
  relatedSearches: 'Related searches',
  scholarlyArticles: 'Scholarly articles',
  shopping: 'Shopping',
  stocksBox: 'Stocks box',
  topSights: 'Top sights',
  topStories: 'Top stories',
  twitter: 'Twitter',
  video: 'Video',
  visualStories: 'Visual stories'
}

export const serpFeaturesKeys = Object.keys(serpFeatures)
